import { createSelector } from 'reselect'

export const getGroups = createSelector(
  (state) => state && state.groups && state.groups.elements && Array.isArray(state.groups.elements)
    ? state.groups.elements
    : [],
  (groups) => groups
)
